module.exports = "/assets/1669d3efd72e779bc6e027772b17a0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8O.png
// module id = 1142
// module chunks = 0